// extracted by mini-css-extract-plugin
export default {"container":"P79xUp","wrapper":"tr91VF","title":"w4kgLO","icon":"Rgs8Bb"};